<template>
  <v-app app>
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list nav dense>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              <router-link to="/">Accueil</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!user">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              <router-link to="/register">Créer un projet</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user">
          <v-list-item-action>
            <v-icon>mdi-mother-heart</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              <router-link to="/account">Mon compte</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar 
      app
      dense
      style="color:#D85D19"
      >
      <v-app-bar-nav-icon style="color:#D85D19" @click.stop="drawer = !drawer" />
      <v-toolbar-title class="logo">Util'Mans</v-toolbar-title>
      <v-spacer />
      <v-btn v-if="user" @click="logout" text style="color:#D85D19">
        Déconnexion
        <v-icon right dark>mdi-logout</v-icon>
      </v-btn>
      <v-btn v-else @click="login" text style="color:#D85D19">
        Connexion
        <v-icon right dark>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content app>
      <router-view />
    </v-content>
    <v-footer app class="d-flex justify-center justify-content-center">
      <div style="font-family:Comfortaa;with:100%;" class="text-center grey--text lighten-3">Coder avec <v-icon color="green lighten-1">mdi-heart</v-icon> par skribascode.fr</div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {},
  data: () => ({
    drawer: null
  }),
  created() {
    this.$store.dispatch("loadUser")
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    logout() {
      this.$store
        .dispatch("signOutAction")
        .then( () => this.$router.replace('/'))
    },
    login() {
      this.$router.replace('Signin')
    }
  }
};
</script>
<style lang="css">
nav a ,
nav a:hover,
nav a:visited,
nav .mdi{
  text-decoration: none;
  color:#D85D19!important;
  font-size: 1.2em;
  font-weight: 500;
}
.logo {
  font-family: "Comfortaa";
  font-size: 1.6em!important;

}
.comfortaa {
  font-family: "Comfortaa"!important;
}
.myh2 {
  font-family: "Comfortaa"!important;
  font-size: 1.8em!important;
  font-weight: 500!important;
  padding: 1em!important;
  text-transform: uppercase;
  color:#D85D19;
}
</style>